/**
 * Pointer position relative to an element using client coordinates.
 * Prefer this over `offsetX` / `offsetY` when the event target may not be the reference element
 * (e.g. overlays, SVG children, or flex/absolute layout), which breaks offset-based math.
 */
export function pointerPositionInElement(
    e: Pick<PointerEvent, 'clientX' | 'clientY'>,
    el: HTMLElement
): { x: number; y: number; nx: number; ny: number; width: number; height: number } {
    const r = el.getBoundingClientRect();
    const width = r.width;
    const height = r.height;
    const x = e.clientX - r.left;
    const y = e.clientY - r.top;
    return {
        x,
        y,
        nx: width > 0 ? x / width : 0,
        ny: height > 0 ? y / height : 0,
        width,
        height
    };
}
